<div class="wrapper">
  <div class="header__wrapper">
    <h2>{{ '+SERVICE_TOOL.CREATE_PAGE_HEADER_TITLE' | translate }}</h2>
    <div class="header__description">
      {{ '+SERVICE_TOOL.CREATE_PAGE_HEADER_DESCRIPTION' | translate }}:
    </div>
  </div>

  <ng-container *ngrxLet="serviceTicketStore.createPageAvailableSteps$ as availableSteps">
    <div class="column">
      <div
        *ngIf="availableSteps.includes(CreatePageSteps.EnterSerial)"
        data-at-step-serial
        class="step__wrapper"
      >
        <h3 class="step__counter">{{ '+SERVICE_TOOL.STEP_GENERIC' | translate }} 1</h3>
        <div class="step__content">
          <app-service-ticket-boiler-serial-field></app-service-ticket-boiler-serial-field>
        </div>
      </div>

      <div
        *ngIf="availableSteps.includes(CreatePageSteps.EnterErrorCode)"
        data-at-step-error-code
        class="step__wrapper"
      >
        <h3 class="step__counter">{{ '+SERVICE_TOOL.STEP_GENERIC' | translate }} 2</h3>
        <div class="step__content">
          <!-- devices have no default error codes -->
          <div *ngIf="deviceErrors.length !== 1; else haveDefaultErrorCode">
            <app-service-ticket-error-field
              [deviceErrors]="deviceErrors"
              [detailsInDifferentLanguage]="detailsInDifferentLanguage"
            ></app-service-ticket-error-field>
            <div *ngIf="availableSteps.includes(CreatePageSteps.EnterOtherErrorCode)">
              <app-service-ticket-other-error-code-field></app-service-ticket-other-error-code-field>
            </div>
            <div *ngIf="availableSteps.includes(CreatePageSteps.CallSupport)">
              <app-service-ticket-call-support></app-service-ticket-call-support>
            </div>
          </div>

          <ng-template #haveDefaultErrorCode>
            <ng-container *ngrxLet="serviceTicketStore.errorCodes$ as errorCodes">
              <app-service-ticket-error-field
                [deviceErrors]="deviceErrors"
                [detailsInDifferentLanguage]="detailsInDifferentLanguage"
                *ngIf="!errorCodes.otherErrorSelected"
              ></app-service-ticket-error-field>
              <div *ngIf="availableSteps.includes(CreatePageSteps.EnterOtherErrorCode)">
                <app-service-ticket-other-error-code-field></app-service-ticket-other-error-code-field>
              </div>
              <app-service-ticket-error-field
                [deviceErrors]="deviceErrors"
                [detailsInDifferentLanguage]="detailsInDifferentLanguage"
                *ngIf="errorCodes.otherErrorSelected"
              ></app-service-ticket-error-field>
              <div *ngIf="availableSteps.includes(CreatePageSteps.CallSupport)">
                <app-service-ticket-call-support></app-service-ticket-call-support>
              </div>
            </ng-container>
          </ng-template>
        </div>
      </div>

      <div
        *ngIf="availableSteps.includes(CreatePageSteps.DetailedInformation)"
        data-at-step-detailed-information
        class="step__wrapper"
      >
        <h3 class="step__counter">{{ '+SERVICE_TOOL.STEP_GENERIC' | translate }} 3</h3>
        <div class="step__content">
          <app-service-ticket-detailed-information></app-service-ticket-detailed-information>
        </div>
      </div>

      <div
        *ngIf="availableSteps.includes(CreatePageSteps.AdditionalArticles)"
        data-at-step-additional-articles
        class="step__wrapper"
      >
        <h3 class="step__counter">{{ '+SERVICE_TOOL.STEP_GENERIC' | translate }} 4</h3>
        <div class="step__content">
          <div>{{ '+SERVICE_TOOL.STEP_ARTICLES_DESCRIPTION' | translate }}</div>
          <app-service-ticket-extra-information></app-service-ticket-extra-information>
        </div>
      </div>
    </div>

    <div class="column">
      <div
        [class.loader--visible]="
          availableSteps.includes(CreatePageSteps.Init) ||
          availableSteps.includes(CreatePageSteps.EnterErrorCodeLoader) ||
          availableSteps.includes(CreatePageSteps.AdditionalArticlesLoader)
        "
        data-at-loader
        class="step__wrapper loader"
      >
        <h3 class="step__fullwidth">
          <vi-loader [isLoading]="true" [message]="'+GENERAL.LOADING_DATA' | translate"></vi-loader>
        </h3>
      </div>
    </div>
  </ng-container>
</div>
